var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWholeFamily = function SvgWholeFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "var(--color-circle)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 16.003a.43.43 0 0 1-.37-.035c-.17-.1-.297-.332-.167-.578l.133.07c.219-.419.469-.82.746-1.203l-.342 1.746Zm0 0 .04.123.166-.315a9.124 9.124 0 0 1 3.103-3.413c.38-.244.775-.461 1.184-.648l-.062-.136m-4.43 4.39 4.15-4.873c.139-.062.297-.042.38.1.07.12.036.321-.1.383m0 0a9.52 9.52 0 0 0-1.204.658 9.264 9.264 0 0 0-3.056 3.287l4.26-3.945Z",
    fill: "url(#WholeFamily_svg__a)",
    stroke: "url(#WholeFamily_svg__b)",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.04 24.182c.21.4.445.784.71 1.149a9.089 9.089 0 0 0 3.578 2.915l.21.096-.052.046a.452.452 0 0 1 .01.452m-4.456-4.658 4.325 4.583m-4.325-4.583a.394.394 0 0 0-.272-.212.432.432 0 0 0-.302.055c-.171.1-.3.332-.172.578a9.97 9.97 0 0 0 3.37 3.704m-2.624-4.125-.613.352a9.82 9.82 0 0 0 3.318 3.648m1.75.658-.13-.075m.13.075-.13-.075m.13.075c-.13.226-.388.245-.572.162a9.74 9.74 0 0 1-1.26-.695m1.702.458c-.08.14-.244.162-.38.1a9.584 9.584 0 0 1-1.24-.683m-.082.125.082-.125m-.082.125.082-.125",
    fill: "url(#WholeFamily_svg__c)",
    stroke: "url(#WholeFamily_svg__d)",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.252 14.672c.262.362.497.744.704 1.143.062.117.16.19.272.212a.431.431 0 0 0 .302-.055c.171-.1.301-.331.172-.578a10.002 10.002 0 0 0-3.38-3.713c-.4-.26-.82-.49-1.255-.686-.183-.082-.44-.064-.571.162a.445.445 0 0 0-.045.318c.024.105.09.217.211.273l.017.008a9.075 9.075 0 0 1 3.573 2.916Z",
    fill: "url(#WholeFamily_svg__e)",
    stroke: "url(#WholeFamily_svg__f)",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.493 28.843a.407.407 0 0 0 .266.198.491.491 0 0 0 .304-.036h.002a9.956 9.956 0 0 0 3.882-3.185c.282-.386.532-.792.755-1.214.128-.248 0-.48-.172-.58a.431.431 0 0 0-.302-.056.394.394 0 0 0-.272.212l-.004.009a9.123 9.123 0 0 1-3.112 3.415 9.62 9.62 0 0 1-1.18.643.387.387 0 0 0-.21.272.452.452 0 0 0 .043.322Z",
    fill: "url(#WholeFamily_svg__g)",
    stroke: "url(#WholeFamily_svg__h)",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.326 10.833a1.756 1.756 0 0 1-1.829-.825 1.78 1.78 0 0 1 .16-2.016 1.742 1.742 0 0 1 1.91-.538 1.775 1.775 0 0 1 1.174 1.624l-1.415 1.755Zm0 0c.816-.146 1.39-.882 1.415-1.689l-1.415 1.689Zm.561-1.723v.012a.906.906 0 0 1-.571.828.903.903 0 0 1-1.01-.272.895.895 0 0 1 .853-1.447c.422.083.72.447.728.88Z",
    fill: "url(#WholeFamily_svg__i)",
    stroke: "url(#WholeFamily_svg__j)",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.911 12.956a.067.067 0 0 0 .03-.047c.005-.027.004-.055.004-.101v-.981a1.232 1.232 0 0 0-.544-1.04l-.01-.007c-.232-.152-.232-.417-.133-.588a.427.427 0 0 1 .235-.197.39.39 0 0 1 .34.054c.615.4.961 1.059.964 1.788l.002.344c.003.236.005.475-.002.71-.017.575-.471.939-1.002.939H18.71l-.183.001c-.128.001-.259.003-.387-.001a.951.951 0 0 1-.784-.425c-.136-.208-.155-.432-.155-.635v-.322c-.001-.217-.002-.434 0-.65l4.71 1.158Zm0 0v.001m0 0c-.013.01-.024.014-.094.014H18.272a.469.469 0 0 1-.18-.021.049.049 0 0 1-.022-.018.118.118 0 0 1-.015-.057 8.067 8.067 0 0 1-.004-.64c.002-.111.005-.224.005-.339 0-.459.167-.858.54-1.106m3.314 2.167-3.314-2.167m0 0c.23-.153.23-.418.13-.59a.428.428 0 0 0-.235-.196.39.39 0 0 0-.34.053m.445.733-.446-.732m0 0a2.098 2.098 0 0 0-.95 1.74l.95-1.74Z",
    fill: "url(#WholeFamily_svg__k)",
    stroke: "url(#WholeFamily_svg__l)",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.566 26.265a1.742 1.742 0 0 0-1.909.538 1.78 1.78 0 0 0-.16 2.016 1.756 1.756 0 0 0 1.829.825c.816-.146 1.39-.882 1.415-1.689l-1.175-1.69Zm0 0a1.775 1.775 0 0 1 1.175 1.624l-1.175-1.624Zm.321 1.657v.01a.906.906 0 0 1-.571.83.903.903 0 0 1-1.01-.273.895.895 0 0 1 .853-1.447c.422.083.72.447.728.88Z",
    fill: "url(#WholeFamily_svg__m)",
    stroke: "url(#WholeFamily_svg__n)",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 28.869a2.098 2.098 0 0 0-.95 1.74v.972c0 .203.02.427.155.634a.95.95 0 0 0 .785.426c.128.004.26.002.387.001l.183-.001h3.085c.53 0 .985-.363 1.002-.938.007-.236.005-.476.002-.71l-.002-.344a2.11 2.11 0 0 0-.964-1.79.39.39 0 0 0-.34-.053.427.427 0 0 0-.235.197c-.1.171-.099.436.134.588l.01.006c.347.231.54.614.543 1.041v.981c0 .046 0 .074-.005.1a.067.067 0 0 1-.029.048v.001c-.013.01-.024.015-.094.015H18.272a.469.469 0 0 1-.18-.022.049.049 0 0 1-.022-.018.118.118 0 0 1-.015-.057 8.069 8.069 0 0 1-.004-.64c.002-.111.005-.224.005-.339 0-.459.167-.858.54-1.105.23-.154.23-.42.13-.59a.429.429 0 0 0-.235-.197.39.39 0 0 0-.34.054Z",
    fill: "url(#WholeFamily_svg__o)",
    stroke: "url(#WholeFamily_svg__p)",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.174 20.24a1.756 1.756 0 0 1-1.829-.825 1.78 1.78 0 0 1 .16-2.016 1.742 1.742 0 0 1 1.91-.538 1.775 1.775 0 0 1 1.174 1.624l-1.415 1.755Zm0 0c.816-.146 1.39-.882 1.415-1.69l-1.415 1.69Zm.561-1.723v.011a.906.906 0 0 1-.571.83.903.903 0 0 1-1.01-.274.895.895 0 0 1 .853-1.447c.422.084.72.448.728.88Z",
    fill: "url(#WholeFamily_svg__q)",
    stroke: "url(#WholeFamily_svg__r)",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 19.463a2.098 2.098 0 0 0-.95 1.74v.972c0 .204.02.427.155.635a.95.95 0 0 0 .785.425c.128.004.26.003.387.002l.183-.002h3.085c.53 0 .985-.363 1.002-.938.007-.235.005-.475.002-.71l-.002-.344a2.109 2.109 0 0 0-.964-1.789.39.39 0 0 0-.34-.053.428.428 0 0 0-.236.196c-.098.172-.098.437.134.588l.01.007c.348.23.541.614.544 1.04v.981c0 .046 0 .075-.005.101a.067.067 0 0 1-.029.048c-.013.01-.024.015-.093.015H28.12a.47.47 0 0 1-.18-.022.049.049 0 0 1-.022-.017.116.116 0 0 1-.015-.057c-.012-.213-.008-.424-.004-.64.002-.111.005-.224.005-.34 0-.458.167-.857.54-1.105.23-.154.23-.419.13-.59a.429.429 0 0 0-.235-.197.39.39 0 0 0-.34.054Z",
    fill: "url(#WholeFamily_svg__s)",
    stroke: "url(#WholeFamily_svg__t)",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m11.893 18.517-.001-.032a1.775 1.775 0 0 0-1.175-1.624 1.742 1.742 0 0 0-1.91.538 1.78 1.78 0 0 0-.16 2.016 1.756 1.756 0 0 0 1.83.825c.815-.146 1.389-.882 1.415-1.69v-.033Zm-.855 0v.012a.906.906 0 0 1-.572.828.903.903 0 0 1-1.01-.273.895.895 0 0 1 .853-1.447c.422.084.72.448.729.88Z",
    fill: "url(#WholeFamily_svg__u)",
    stroke: "url(#WholeFamily_svg__v)",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.062 22.362a.067.067 0 0 0 .029-.048.512.512 0 0 0 .005-.1v-.981a1.233 1.233 0 0 0-.544-1.041l-.01-.006c-.233-.152-.233-.417-.134-.589a.428.428 0 0 1 .235-.196.39.39 0 0 1 .34.053c.616.4.961 1.059.964 1.789l.003.344c.002.235.005.475-.003.71-.016.575-.471.938-1.001.938H8.86c-.06 0-.121 0-.183.002a9.812 9.812 0 0 1-.388-.002.951.951 0 0 1-.784-.425c-.136-.208-.155-.431-.155-.635v-.322c-.001-.216-.002-.433 0-.65l4.71 1.159Zm0 0h-.001m0 0c-.012.01-.024.015-.093.015H8.422a.47.47 0 0 1-.18-.022.05.05 0 0 1-.022-.017.117.117 0 0 1-.014-.057 8.07 8.07 0 0 1-.004-.64c.002-.111.004-.224.004-.34 0-.458.168-.857.54-1.105h.001m3.314 2.167-3.314-2.167m0 0c.23-.154.23-.419.13-.59a.429.429 0 0 0-.236-.197.39.39 0 0 0-.34.054m.446.733-.446-.733m0 0a2.098 2.098 0 0 0-.95 1.74l.95-1.74Z",
    fill: "url(#WholeFamily_svg__w)",
    stroke: "url(#WholeFamily_svg__x)",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__a",
    x1: 11.394,
    y1: 13.49,
    x2: 16.401,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__b",
    x1: 11.394,
    y1: 13.49,
    x2: 16.401,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__c",
    x1: 11.393,
    y1: 26.505,
    x2: 16.401,
    y2: 26.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__d",
    x1: 11.393,
    y1: 26.505,
    x2: 16.401,
    y2: 26.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__e",
    x1: 23.59,
    y1: 13.492,
    x2: 28.604,
    y2: 13.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__f",
    x1: 23.59,
    y1: 13.492,
    x2: 28.604,
    y2: 13.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__g",
    x1: 23.587,
    y1: 26.507,
    x2: 28.604,
    y2: 26.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__h",
    x1: 23.587,
    y1: 26.507,
    x2: 28.604,
    y2: 26.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__i",
    x1: 18.407,
    y1: 9.11,
    x2: 21.592,
    y2: 9.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__j",
    x1: 18.407,
    y1: 9.11,
    x2: 21.592,
    y2: 9.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__k",
    x1: 17.349,
    y1: 11.905,
    x2: 22.652,
    y2: 11.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__l",
    x1: 17.349,
    y1: 11.905,
    x2: 22.652,
    y2: 11.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__m",
    x1: 18.407,
    y1: 27.921,
    x2: 21.592,
    y2: 27.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__n",
    x1: 18.407,
    y1: 27.921,
    x2: 21.592,
    y2: 27.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__o",
    x1: 17.349,
    y1: 30.716,
    x2: 22.652,
    y2: 30.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__p",
    x1: 17.349,
    y1: 30.716,
    x2: 22.652,
    y2: 30.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__q",
    x1: 28.255,
    y1: 18.517,
    x2: 31.44,
    y2: 18.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__r",
    x1: 28.255,
    y1: 18.517,
    x2: 31.44,
    y2: 18.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__s",
    x1: 27.198,
    y1: 21.31,
    x2: 32.5,
    y2: 21.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__t",
    x1: 27.198,
    y1: 21.31,
    x2: 32.5,
    y2: 21.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__u",
    x1: 8.557,
    y1: 18.517,
    x2: 11.743,
    y2: 18.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__v",
    x1: 8.557,
    y1: 18.517,
    x2: 11.743,
    y2: 18.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__w",
    x1: 7.5,
    y1: 21.31,
    x2: 12.802,
    y2: 21.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WholeFamily_svg__x",
    x1: 7.5,
    y1: 21.31,
    x2: 12.802,
    y2: 21.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgWholeFamily;